<template>
  <div v-if="canExport">
    <json-excel
        class   = "btn btn-default"
        :name    = "nameFile"
        :title  = "title"
        :fields = "jsonFields"
        sortField = "total_time"
        :escapeCsv = "true"
        type    = "csv"
        :before-generate = "beforeGenerate"
        :before-finish = "beforeFinish"
        :fetch  = "doExport">
        <el-tooltip
          placement="top"
          :content="$t('information.export_report_button')"
        >
          <chip class="export-lesson" v-loading.fullscreen.lock="exportLoading">
            {{$t('common.export_report')}}
          </chip>
        </el-tooltip>
    </json-excel>
  </div>
</template>

<script>
  import Chip from '@/components/common/Chip'
  import JsonExcel from '@/components/lib/JsonExcel'
  import { format, toDate, startOfMonth } from 'date-fns'
  import { mapGetters, mapActions, mapState } from 'vuex'
  import {
  pathOr, length, join, prop, compose, concat, __
  } from 'ramda'
  import props from 'ramda/src/props'
  export default {
    components: {
      Chip,
      JsonExcel
    },
    props: {
      startDate: {
        default: () => startOfMonth(Date.now())
      },
      endDate: {
        default: () => toDate(Date.now())
      },
      scope: {
        default: 'daily'
      },
      reportData: {
        type: Array,
         default: ()=>[]
      },
      canExport: {
          default: false
      }
    },
    data() {
      return {
        exportLoading: false,
      }
    },
    methods: {
      getDatesBetweenDates(startDate, endDate) {
        let dates = []
        const theDate = new Date(startDate)
        while (theDate <= endDate) {
          var str = format(new Date(theDate), 'MMM dd')
          dates = [...dates, str]
          theDate.setDate(theDate.getDate() + 1)
        }
        return dates
      },
      getReportData() {
        this.reportData.map((item, idx) => {
          item.data.map((time, index) => {
            this.reportData[idx].data[index]=(time/60).toFixed(0)
          });
        });
        return this.reportData;
      },
      async doExport() {
        try {
          if (length(this.reportData)!=0) {
            return [...this.reportData]
          }
          try {
            this.$gtag.event(`${document.title}-export report`, {
              'category': `Export`,
              'label': `Export Report`
            });
          }
          catch (error) {
            error
          }
          return {};
        } catch(error) {
          return error
        }
      },
      beforeGenerate(){
        return this.exportLoading = true;
      },
      beforeFinish(){
        return this.exportLoading = false;
      }
    },
    computed: {
      ...mapGetters({
        getCurrentClass: 'classes/getCurrentClass',
        currentClassAllStudent: 'classes/getCurrentClassAllStudent',
      }),
      ...mapGetters('students', [
        'paginateStudents',
      ]),
      title() {
        const formatedStartDate = format(new Date(this.startDate), 'dd MMM yyyy')
        const formatedEndDate = format(new Date(this.endDate), 'dd MMM yyyy')
        let titleTime = `${formatedStartDate} - ${formatedEndDate}`
        return [ this.$t('common.class_time_export_title', [this.getCurrentClass.name]) , titleTime]
      },
      jsonFields() {
        let dates =  this.getDatesBetweenDates(this.startDate, this.endDate)
        const ob = {
          'Student Name': 'name',
          'Student Email': 'email',
        }
        const datesObject = dates.map((date, index) => {
          ob[date] = 'data.'+index
        });
        return ob;
      },
      nameFile: compose(
        concat(__, '.csv'),
        join(' '),
        prop('title')
      )
    }
  }
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';
.export-lesson {
  margin-right: 10px;
  padding: 11px 11px;
}
</style>
